import React from 'react';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { COLORS } from './annotatorConstants';

const AnnotatorSettingsPanel = ({ color, setColor, lineWidth, setLineWidth, annotationCount }) => {
  return (
    <div className="w-48 bg-[#F8F7F4] border-l border-[#E5E4E0] p-3 flex flex-col gap-4">
      <div>
        <Label className="text-xs text-[#5C5F5C] uppercase tracking-wider mb-2 block">
          Color
        </Label>
        <div className="grid grid-cols-3 gap-1">
          {COLORS.map(c => (
            <button
              key={c.value}
              onClick={() => setColor(c.value)}
              className={`w-8 h-8 rounded border-2 transition-all ${
                color === c.value ? 'border-[#2A2C2A] scale-110' : 'border-transparent'
              }`}
              style={{ backgroundColor: c.value }}
              title={c.name}
            />
          ))}
        </div>
      </div>

      <div>
        <Label className="text-xs text-[#5C5F5C] uppercase tracking-wider mb-2 block">
          Line Width
        </Label>
        <Select value={lineWidth.toString()} onValueChange={v => setLineWidth(parseInt(v))}>
          <SelectTrigger className="bg-white border-[#E5E4E0]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1">Thin (1px)</SelectItem>
            <SelectItem value="2">Normal (2px)</SelectItem>
            <SelectItem value="3">Medium (3px)</SelectItem>
            <SelectItem value="4">Thick (4px)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex-1" />

      <div className="text-xs text-[#5C5F5C]">
        <p className="font-semibold mb-1">Annotations: {annotationCount}</p>
        <p>Mark regions of interest for more targeted AI analysis.</p>
      </div>
    </div>
  );
};

export default AnnotatorSettingsPanel;
